import { Link, Box } from '@amzn/awsui-components-core';
import { ContentType } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { getContentPath } from '../../common/ContentPaths';
import { getHighlightedText } from '../utils/SearchResultUtils';
import AppContextProps from '../../contexts/AppContextProps';
import { withAppContext } from '../../contexts/AppContext';
import { convertEntities } from '@amzn/awscat-editor';

interface Props extends AppContextProps {
  contentName: string;
  contentType?: ContentType;
  contentId?: string;
  workflowId?: number;
  url?: string;
  highlightWord?: string;
  target?: '_blank' | '_self';
}

const PublicationLink: React.FC<Props> = ({
  highlightWord,
  contentId,
  contentName,
  url,
  contentType,
  target,
  appContext,
}) => {
  const highlightedContentName = getHighlightedText(
    convertEntities(contentName, appContext.entities),
    // @ts-expect-error TS2345 - strict migration
    highlightWord,
  );
  if (contentType === ContentType.ExternalResource) {
    return (
      <span>
        <Link variant="secondary" href={url} target="_blank" external>
          {highlightedContentName}
        </Link>
      </span>
    );
  }
  if (target) {
    return (
      <Box padding={{ left: 'xs' }}>
        <Link
          external
          target={target}
          href={getContentPath({ contentId: contentId ?? '', mode: 'publication' })}
          variant="secondary"
        >
          {highlightedContentName}
        </Link>
      </Box>
    );
  }
  return (
    <Link
      variant="secondary"
      href={getContentPath({ contentId: contentId ?? '', mode: 'publication' })}
    >
      {highlightedContentName}
    </Link>
  );
};

export default withAppContext(PublicationLink);
